import {EventBus} from "../../../../common/ts/events/EventBus";
import SessionStorageService from "../../../../common/ts/services/SessionStorageService";
import PageGallery from "../../../../common/ts/components/PageGallery";
import LazyLoadingComponent from "../../../../common/ts/components/LazyLoadingComponent";
import handleShowSimilarAdsPopup from "../../serp/handleShowSimilarAdsPopup";
import {isDesktopDevice} from "../../device";
import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

type RetrievalEventParams = {
    search: string,
    pageViewId: string,
    pageSectionId: string,
    retrievalEvent: (params: RetrievalEventParams) => void,
    clickedListing: HTMLElement,
    adId: string,
    numberOfAds: number,
    ids: (string | null)[],
    successEventClass: any,
}

type SimilarClickData = {
    pageViewId: string,
    search: string,
    pageSectionId: string,
    retrievalEvent: (params: RetrievalEventParams) => void,
};

let eventBus: EventBus;
let adsClicked: Array<string>;
let lazyLoading: LazyLoadingComponent;
let shouldDisplaySimilarAdsPopup: boolean;
let device: string;

function init({
  device: dv,
  displayingSimilarAdsPopup = true,
  similarClickAdsData = undefined,
  ev = EventBus.getInstance(),
}: {
    device?: string,
    displayingSimilarAdsPopup?: boolean,
    similarClickAdsData?: SimilarClickData | undefined,
    containerSelector?: string,
    ev?: any,
}) {
    device = dv || ''
    eventBus = ev;
    shouldDisplaySimilarAdsPopup = displayingSimilarAdsPopup;
    lazyLoading = new LazyLoadingComponent();
    adsClicked = [];
    eventBus = ev;
    eventBus.subscribe(SimilarAdsReceivedEvent.TYPE, similarAdsReceivedEventHandler)

    const snippets = Array.from(document.querySelectorAll('[data-listingblock]'));
    snippets.forEach((item) => {
        const id = (item as HTMLElement).dataset.idanuncio!.toString()
        registerEvents(id, item as HTMLElement, similarClickAdsData)
    })
}


function registerEvents(id: string, listing: HTMLElement, similarClickAdsData: SimilarClickData | undefined) {
    const isCPC = listing.dataset.iscpc === "true"
    if (isCPC) {
        showViewedSnippets(listing)
        registerCpcListingEvents(id, listing)
        similarClickAdsData && listing.addEventListener(
            'click',
            (e) => displaySimilarsClick(e, similarClickAdsData!)
        )
    }
}

function registerCpcListingEvents(id: string, cpcListing: HTMLElement) {
    cpcListing.addEventListener('click', (e) => {
        // @ts-ignore
        const customEventOrigin: string = e.target.dataset.eventOrigin;
        if (customEventOrigin === "info-button") {
            showListingDescription(cpcListing);
        } else if (customEventOrigin === "back-button") {
            hideListingDescription(cpcListing);
        } else {
            setupViewedAd(cpcListing);
            handleOpenAd(id, cpcListing);
        }
    });
}

function handleOpenAd(id: string, cpcListing: HTMLElement) {
    goToDetail(cpcListing);
    shouldDisplaySimilarAdsPopup && handleShowSimilarAdsPopup(id);
}


function setupViewedAd(cpcListing: HTMLElement) {
    const localStorageService = new SessionStorageService();
    const cpcListingId = cpcListing.getAttribute("data-idanuncio");
    const isDesktop = isDesktopDevice(device) || existsDataProperty("data-device", "desktop");
    if (
        cpcListingId &&
        !hasBeenVisited(cpcListingId) &&
        isDesktop
    ) {
        localStorageService.saveArray("clickedIds", [cpcListingId]);
        showViewedLabel(cpcListing);
        changeTitleColor(cpcListing);
    }
}


function showListingDescription(listing: HTMLElement) {
    const unitContent = listing.querySelector('div[data-itemcontent="true"]') as HTMLElement;
    const contentHeight = unitContent?.clientHeight;
    const unitDescription = listing.querySelector('div[data-itemdescription="true"]') as HTMLElement;
    const infoButton = listing.querySelector('div[data-infobutton="true"]') as HTMLElement;
    const backButton = listing.querySelector('div[data-backbutton="true"]') as HTMLElement;

    infoButton.style.display = 'none';
    backButton.style.display = 'block';

    unitContent.style.display = 'none';
    unitDescription.style.display = 'block';
    unitDescription.style.height = `${contentHeight}px`;
}

function goToDetail(cpcListing: HTMLElement) {
    const href = cpcListing.getAttribute("data-href");
    // @ts-ignore
    window.open(href, "_blank");
}

function hideListingDescription(listing: HTMLElement) {
    const unitContent = listing.querySelector('div[data-itemcontent="true"]') as HTMLElement;
    const unitDescription = listing.querySelector('div[data-itemdescription="true"]') as HTMLElement;
    const infoButton = listing.querySelector('div[data-infobutton="true"]') as HTMLElement;
    const backButton = listing.querySelector('div[data-backbutton="true"]') as HTMLElement;

    infoButton.style.display = 'block';
    backButton.style.display = 'none';

    unitContent.style.display = 'block';
    unitDescription.style.display = 'none';
}

async function displaySimilarsClick(event: Event, similarClickAdsData: SimilarClickData){
    // @ts-ignore
    const customEventOrigin: string = event.target.dataset.eventOrigin;
    const notValidSimilarClickEventOrigins = ["info-button", "back-button"];
    if (!notValidSimilarClickEventOrigins.includes(customEventOrigin)) {

        const htmlElement = event.target as HTMLElement;
        const clickedListing = htmlElement.closest("[data-listingblock]")! as HTMLElement;
        const adId = clickedListingId(clickedListing)

        if (!adsClicked.includes(adId)) {
            const isSponsoredListing = clickedListing.dataset.sponsored === 'sponsored'
            const numberOfAds = isSponsoredListing ? 1 : 3
            const ids = Array.from(document.querySelectorAll('[data-idanuncio]')).map(e => e.getAttribute('data-idanuncio'))

            similarClickAdsData.retrievalEvent({
                ...similarClickAdsData,
                clickedListing,
                adId,
                numberOfAds,
                ids,
                successEventClass: SimilarAdsReceivedEvent
            })
        }
    }
}

function showViewedSnippets(element: HTMLElement): void {
    const cpcListingId = element.getAttribute("data-idanuncio");
    if (
        cpcListingId &&
        hasBeenVisited(cpcListingId) &&
        existsDataProperty("data-device", "desktop")
    ) {
        showViewedLabel(element);
        changeTitleColor(element);
    }
}

function hasBeenVisited(cpcListingId: string) {
    const localStorageService = new SessionStorageService();
    return cpcListingId && localStorageService.valueExistsInArray("clickedIds", cpcListingId);
}

function existsDataProperty(property: string, value: string) {
    return document.querySelector(`div[${property}=${value}]`);
}

function showViewedLabel(cpcSnippet: HTMLElement) {
    cpcSnippet
        .querySelector('div[data-status-wrapper="true"]')
        ?.classList.add("listing-card__status--wrapper--visible");
}

function changeTitleColor(cpcSnippet: HTMLElement) {
    cpcSnippet.querySelector("a")?.classList.add("text-mitula-color")
}

interface SimilarAdsReceivedPayload {
    response: string,
    clickedListing: HTMLElement,
    search: string,
    pageViewId: string,
    pageSectionId: string,
    retrievalEvent: (params: RetrievalEventParams) => void,
}

class SimilarAdsReceivedEvent implements WhitelabelEventWithPayload<SimilarAdsReceivedPayload> {
    type: string;
    static readonly TYPE: string = 'similar-ads-received';
    payload: SimilarAdsReceivedPayload;

    constructor(payload: SimilarAdsReceivedPayload) {
        this.type = SimilarAdsReceivedEvent.TYPE;
        this.payload = payload;
    }
}

function similarAdsReceivedEventHandler(event: WhitelabelEvent) {
    // TODO this event handler has many side effects, it should be refactored to ease testing
    const {
        payload: {
            response,
            clickedListing,
            ...similarClickAdsData
        }
    } = (event as SimilarAdsReceivedEvent)

    renderSimilarAds(response, clickedListing, similarClickAdsData)
}

function renderSimilarAds(
    html: string,
    clickedListing: HTMLElement,
    similarClickAdsData: SimilarClickData
) {
    const elements = new DOMParser().parseFromString(html, 'text/html')
    const adId = clickedListingId(clickedListing);
    const isCPC = clickedListing.dataset.iscpc === "true"

    Array.from(elements.body.children).forEach(element => {
        const htmlElement = element as HTMLElement
        if (!isCPC) {
            htmlElement.querySelector(".swiper-container")!.classList.add("swiper-container-similar-" + adId)
        }
        htmlElement.dataset.similarClickAd = adId
    })
    let similarAds =  document.querySelectorAll(`[data-similar-click-ad="` + adId + `"]`);

    if(similarAds.length == 0) {
        clickedListing.parentElement!.insertAdjacentHTML('afterend', elements.body.innerHTML);
        similarAds =  document.querySelectorAll(`[data-similar-click-ad="` + adId + `"]`);
    }
    lazyLoading.checkLazyLoad();

    if (!isCPC) {
        new PageGallery(".swiper-container-similar-" + adId)
    }
    adsClicked.push(adId)
    similarAds.forEach(element => {
        const similarClickAdElement = element.querySelector(`[data-idanuncio]`) as HTMLElement
        adsClicked.push(similarClickAdElement.dataset.idanuncio!.toString())
        registerEvents(adId, similarClickAdElement, similarClickAdsData)
    })
}

function clickedListingId(clickedListing: HTMLElement) {
    return clickedListing.dataset.idanuncio!.toString();
}

export default {
    init,
}